import { useCallback } from 'react';
import { LogService } from '../services/log-service';
import { User } from '@capacitor-firebase/authentication';

export const useLog = () => {
  const logService = LogService.getInstance();

  const logInfo = useCallback(
    (
      message: string,
      props?: Record<string, any>,
      tags?: Record<string, string>,
      level: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug' = 'info'
    ) => {
      logService.logInfo(
        message,
        {
          ...props,
        },
        tags,
        level
      );
    },
    []
  );

  const logError = useCallback(
    (
      error: unknown,
      props?: Record<string, any>,
      tags?: Record<string, string>,
      level: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug' = 'error'
    ) => {
      logService.logError(error, props, tags, level);
    },
    []
  );

  const setUser = useCallback((user: User | null) => {
    logService.setUser(user);
  }, []);

  return { logInfo, logError, setUser };
};
